/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ExtendedJsonSchema } from '@squiz/dxp-ai-client';
import { formatDate } from '@squiz/dxp-console-support';

export const formatColumnValue = <T>(value: T, schema: ExtendedJsonSchema): string => {
  switch (schema.type) {
    case 'string':
      if (schema.format === 'date') {
        return formatDate(String(value), false);
      } else if (schema.format === 'date-time') {
        return formatDate(String(value), true);
      }

      return String(value);
    case 'number':
      return String(value);
    case 'boolean':
      return value ? `Yes` : `No`;
    default:
      if (value === undefined || value === null || typeof value === 'object') {
        return '';
      }

      return String(value);
  }
};
